import { isLocalHost } from '../util/util';
import { del } from './client';

const getBaseEndpoint = () => isLocalHost()
? 'http://localhost:5001/codellama-f95c6/us-central1/api/api/user'
: `https://${window.location.hostname}/api/user`;

const deleteAccount = async () => {
  await del('delete_account', getBaseEndpoint());
}

export {
  deleteAccount
}
